import React, { useState } from "react";

import { initialState, UserContext } from "./UserContext";
import { IUserContextProps } from "./UserContextInterfaces";
import { getUser } from "utilities/storageUtilities";

export const UserContextProvider: React.FC<IUserContextProps> = ({ children }) => {
    const [tokenAvailable, setTokenAvailable] = useState(initialState.tokenAvailable);
    const [userId, setUserId] = useState(getUser());

    const handleUserId = (id: number) => {
        setUserId(id);
    };

    const handleTokenAvailable = (value: boolean) => {
        setTokenAvailable(value);
    };

    const providerValue = {
        user_id: userId,
        tokenAvailable,
        handleTokenAvailable,
        handleUserId,
    };

    return <UserContext.Provider value={providerValue}>{children}</UserContext.Provider>;
};
